@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-235_573_374)
internal val Res.string.exp_content_il_verbo_ma_i_9: StringResource by lazy {
      StringResource("string:exp_content_il_verbo_ma_i_9", "exp_content_il_verbo_ma_i_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61318, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61146, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62726, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58886, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56922, 71),
      ))
    }

@delegate:ResourceContentHash(715_457_037)
internal val Res.string.exp_content_impariamo_alcune_parole_base_sugli_animali: StringResource by
    lazy {
      StringResource("string:exp_content_impariamo_alcune_parole_base_sugli_animali", "exp_content_impariamo_alcune_parole_base_sugli_animali", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61406, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61218, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62806, 126),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 58958, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56994, 122),
      ))
    }

@delegate:ResourceContentHash(-1_661_722_067)
internal val Res.string.exp_content_impariamo_alcune_parole_base_sul_cibo: StringResource by lazy {
      StringResource("string:exp_content_impariamo_alcune_parole_base_sul_cibo", "exp_content_impariamo_alcune_parole_base_sul_cibo", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61537, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61353, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 62933, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59081, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57117, 113),
      ))
    }

@delegate:ResourceContentHash(1_616_981_554)
internal val Res.string.exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit: StringResource by
    lazy {
      StringResource("string:exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit", "exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61663, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61483, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63059, 157),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59191, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57231, 141),
      ))
    }

@delegate:ResourceContentHash(749_068_234)
internal val Res.string.exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili: StringResource by
    lazy {
      StringResource("string:exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili", "exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61813, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61629, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63217, 169),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59325, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57373, 145),
      ))
    }

@delegate:ResourceContentHash(-800_856_777)
internal val Res.string.exp_content_impariamo_pronomi_suffissi: StringResource by lazy {
      StringResource("string:exp_content_impariamo_pronomi_suffissi", "exp_content_impariamo_pronomi_suffissi", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 62313, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62181, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63745, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59829, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57861, 94),
      ))
    }

@delegate:ResourceContentHash(360_240_918)
internal val Res.string.exp_content_impariamo_pronomi_suffissi_1: StringResource by lazy {
      StringResource("string:exp_content_impariamo_pronomi_suffissi_1", "exp_content_impariamo_pronomi_suffissi_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 61967, 184),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61803, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63387, 192),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59487, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57519, 196),
      ))
    }

@delegate:ResourceContentHash(-734_664_937)
internal val Res.string.exp_content_impariamo_pronomi_suffissi_2: StringResource by lazy {
      StringResource("string:exp_content_impariamo_pronomi_suffissi_2", "exp_content_impariamo_pronomi_suffissi_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 62152, 160),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 61992, 188),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63580, 164),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59664, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57716, 144),
      ))
    }

@delegate:ResourceContentHash(944_938_857)
internal val Res.string.exp_content_in_egiziano_antico_non_c_erano_regole_rigide_: StringResource by
    lazy {
      StringResource("string:exp_content_in_egiziano_antico_non_c_erano_regole_rigide_", "exp_content_in_egiziano_antico_non_c_erano_regole_rigide_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 62420, 249),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62288, 253),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 63852, 293),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 59924, 237),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 57956, 229),
      ))
    }

@delegate:ResourceContentHash(117_672_936)
internal val Res.string.exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost: StringResource by
    lazy {
      StringResource("string:exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost", "exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 62670, 257),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62542, 253),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 64146, 257),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 60162, 233),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58186, 221),
      ))
    }

@delegate:ResourceContentHash(1_221_921_225)
internal val Res.string.exp_content_in_genere_si_mettono_alla_fine_della_parola_m: StringResource by
    lazy {
      StringResource("string:exp_content_in_genere_si_mettono_alla_fine_della_parola_m", "exp_content_in_genere_si_mettono_alla_fine_della_parola_m", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 62928, 213),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62796, 201),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 64404, 209),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 60396, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58408, 201),
      ))
    }

@delegate:ResourceContentHash(-1_313_703_990)
internal val Res.string.exp_content_in_italiano_usiamo_preposizioni_articolate_co: StringResource by
    lazy {
      StringResource("string:exp_content_in_italiano_usiamo_preposizioni_articolate_co", "exp_content_in_italiano_usiamo_preposizioni_articolate_co", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63142, 265),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 62998, 273),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 64614, 361),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 60594, 273),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58610, 241),
      ))
    }

@delegate:ResourceContentHash(1_016_816_372)
internal val Res.string.exp_content_in_mezzo_quadrato_orizzontale: StringResource by lazy {
      StringResource("string:exp_content_in_mezzo_quadrato_orizzontale", "exp_content_in_mezzo_quadrato_orizzontale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63408, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63272, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 64976, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 60868, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58852, 89),
      ))
    }

@delegate:ResourceContentHash(-939_753_985)
internal val Res.string.exp_content_in_mezzo_quadrato_verticale: StringResource by lazy {
      StringResource("string:exp_content_in_mezzo_quadrato_verticale", "exp_content_in_mezzo_quadrato_verticale", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63510, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63362, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65070, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 60958, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 58942, 83),
      ))
    }

@delegate:ResourceContentHash(-533_221_390)
internal val Res.string.exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_: StringResource by
    lazy {
      StringResource("string:exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_", "exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63606, 173),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63446, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65158, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61046, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59026, 157),
      ))
    }

@delegate:ResourceContentHash(125_317_576)
internal val Res.string.exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s: StringResource by
    lazy {
      StringResource("string:exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s", "exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63780, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63620, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65336, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61208, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59184, 165),
      ))
    }

@delegate:ResourceContentHash(-1_637_151_275)
internal val Res.string.exp_content_in_questa_sezione_vedremo_i_principali_fondam: StringResource by
    lazy {
      StringResource("string:exp_content_in_questa_sezione_vedremo_i_principali_fondam", "exp_content_in_questa_sezione_vedremo_i_principali_fondam", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 63958, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63782, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65514, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61358, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59350, 169),
      ))
    }

@delegate:ResourceContentHash(5_759_850)
internal val Res.string.exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt: StringResource by
    lazy {
      StringResource("string:exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt", "exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64140, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 63960, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65704, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61528, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59520, 121),
      ))
    }

@delegate:ResourceContentHash(1_782_874_077)
internal val Res.string.exp_content_in_questo_caso_invece_di_indicare_un_suono_in: StringResource by
    lazy {
      StringResource("string:exp_content_in_questo_caso_invece_di_indicare_un_suono_in", "exp_content_in_questo_caso_invece_di_indicare_un_suono_in", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64262, 217),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64090, 193),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 65842, 201),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61658, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59642, 197),
      ))
    }

@delegate:ResourceContentHash(2_079_296_810)
internal val Res.string.exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non: StringResource
    by lazy {
      StringResource("string:exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non", "exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64480, 174),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64284, 166),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66044, 178),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 61856, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 59840, 162),
      ))
    }

@delegate:ResourceContentHash(1_195_980_814)
internal val Res.string.exp_content_in_un_quarto_di_quadrato: StringResource by lazy {
      StringResource("string:exp_content_in_un_quarto_di_quadrato", "exp_content_in_un_quarto_di_quadrato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64655, 88),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64451, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66223, 76),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62027, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60003, 80),
      ))
    }

@delegate:ResourceContentHash(1_902_474_645)
internal val Res.string.exp_content_in_viaggio_sul_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_1", "exp_content_in_viaggio_sul_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65423, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65231, 121),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67035, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62775, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60735, 117),
      ))
    }

@delegate:ResourceContentHash(154_536_665)
internal val Res.string.exp_content_in_viaggio_sul_nilo_10: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_10", "exp_content_in_viaggio_sul_nilo_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64744, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64532, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66300, 150),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62108, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60084, 126),
      ))
    }

@delegate:ResourceContentHash(-1_238_439_443)
internal val Res.string.exp_content_in_viaggio_sul_nilo_11: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_11", "exp_content_in_viaggio_sul_nilo_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 64891, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64675, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66451, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62239, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60211, 118),
      ))
    }

@delegate:ResourceContentHash(-2_004_600_757)
internal val Res.string.exp_content_in_viaggio_sul_nilo_12: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_12", "exp_content_in_viaggio_sul_nilo_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65006, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64806, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66598, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62366, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60330, 122),
      ))
    }

@delegate:ResourceContentHash(1_466_865_897)
internal val Res.string.exp_content_in_viaggio_sul_nilo_13: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_13", "exp_content_in_viaggio_sul_nilo_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65137, 114),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 64929, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66721, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62489, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60453, 114),
      ))
    }

@delegate:ResourceContentHash(-1_932_397_693)
internal val Res.string.exp_content_in_viaggio_sul_nilo_14: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_14", "exp_content_in_viaggio_sul_nilo_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65252, 170),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65056, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 66844, 190),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62604, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60568, 166),
      ))
    }

@delegate:ResourceContentHash(1_177_601_178)
internal val Res.string.exp_content_in_viaggio_sul_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_2", "exp_content_in_viaggio_sul_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65569, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65353, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67157, 133),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62885, 109),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60853, 101),
      ))
    }

@delegate:ResourceContentHash(1_415_223_950)
internal val Res.string.exp_content_in_viaggio_sul_nilo_3: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_3", "exp_content_in_viaggio_sul_nilo_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65695, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65451, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67291, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 62995, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 60955, 101),
      ))
    }

@delegate:ResourceContentHash(1_027_043_191)
internal val Res.string.exp_content_in_viaggio_sul_nilo_4: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_4", "exp_content_in_viaggio_sul_nilo_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65797, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65557, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67385, 129),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63093, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61057, 141),
      ))
    }

@delegate:ResourceContentHash(-508_868_580)
internal val Res.string.exp_content_in_viaggio_sul_nilo_5: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_5", "exp_content_in_viaggio_sul_nilo_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 65955, 121),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65687, 109),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67515, 113),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63223, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61199, 105),
      ))
    }

@delegate:ResourceContentHash(1_226_168_134)
internal val Res.string.exp_content_in_viaggio_sul_nilo_6: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_6", "exp_content_in_viaggio_sul_nilo_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66077, 129),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65797, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67629, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63337, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61305, 117),
      ))
    }

@delegate:ResourceContentHash(-1_645_589_594)
internal val Res.string.exp_content_in_viaggio_sul_nilo_7: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_7", "exp_content_in_viaggio_sul_nilo_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66207, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65915, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67751, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63463, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61423, 81),
      ))
    }

@delegate:ResourceContentHash(1_843_671_432)
internal val Res.string.exp_content_in_viaggio_sul_nilo_8: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_8", "exp_content_in_viaggio_sul_nilo_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66293, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 65997, 113),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67837, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63553, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61505, 125),
      ))
    }

@delegate:ResourceContentHash(541_380_855)
internal val Res.string.exp_content_in_viaggio_sul_nilo_9: StringResource by lazy {
      StringResource("string:exp_content_in_viaggio_sul_nilo_9", "exp_content_in_viaggio_sul_nilo_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66419, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66111, 137),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 67975, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63671, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61631, 133),
      ))
    }

@delegate:ResourceContentHash(1_438_065_854)
internal val Res.string.exp_content_incredibile_abbiamo_appena_fatto_una_scoperta: StringResource by
    lazy {
      StringResource("string:exp_content_incredibile_abbiamo_appena_fatto_una_scoperta", "exp_content_incredibile_abbiamo_appena_fatto_una_scoperta", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66569, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66249, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68113, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63805, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61765, 133),
      ))
    }

@delegate:ResourceContentHash(-931_033_139)
internal val Res.string.exp_content_infatti_se_necessario_i_segni_potevano_essere: StringResource by
    lazy {
      StringResource("string:exp_content_infatti_se_necessario_i_segni_potevano_essere", "exp_content_infatti_se_necessario_i_segni_potevano_essere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66727, 237),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66403, 261),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68267, 265),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 63951, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 61899, 229),
      ))
    }

@delegate:ResourceContentHash(802_469_104)
internal val Res.string.exp_content_iniziamo_a_leggere_qualche_parola: StringResource by lazy {
      StringResource("string:exp_content_iniziamo_a_leggere_qualche_parola", "exp_content_iniziamo_a_leggere_qualche_parola", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 66965, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66665, 101),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68533, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64213, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62129, 97),
      ))
    }

@delegate:ResourceContentHash(1_289_715_739)
internal val Res.string.exp_content_iniziamo_a_studiare_i_primi_simboli: StringResource by lazy {
      StringResource("string:exp_content_iniziamo_a_studiare_i_primi_simboli", "exp_content_iniziamo_a_studiare_i_primi_simboli", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67075, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66767, 119),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68635, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64315, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62227, 107),
      ))
    }

@delegate:ResourceContentHash(649_481_581)
internal val Res.string.exp_content_iniziamo_col_caso_piu_semplice: StringResource by lazy {
      StringResource("string:exp_content_iniziamo_col_caso_piu_semplice", "exp_content_iniziamo_col_caso_piu_semplice", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67195, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66887, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68755, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64419, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62335, 102),
      ))
    }

@delegate:ResourceContentHash(-966_755_860)
internal val Res.string.exp_content_insomma_ci_vuole_un_po_di_pratica: StringResource by lazy {
      StringResource("string:exp_content_insomma_ci_vuole_un_po_di_pratica", "exp_content_insomma_ci_vuole_un_po_di_pratica", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67302, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 66986, 117),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68862, 109),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64518, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62438, 105),
      ))
    }

@delegate:ResourceContentHash(858_779_446)
internal val Res.string.exp_content_intro_vso_1: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_1", "exp_content_intro_vso_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67412, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67104, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 68972, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64624, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62544, 63),
      ))
    }

@delegate:ResourceContentHash(849_424_242)
internal val Res.string.exp_content_intro_vso_2: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_2", "exp_content_intro_vso_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67476, 51),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67172, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69044, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64692, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62608, 55),
      ))
    }

@delegate:ResourceContentHash(-1_184_319_346)
internal val Res.string.exp_content_intro_vso_3: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_3", "exp_content_intro_vso_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67528, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67228, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69100, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64748, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62664, 55),
      ))
    }

@delegate:ResourceContentHash(1_185_876_407)
internal val Res.string.exp_content_intro_vso_4: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_4", "exp_content_intro_vso_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67588, 115),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67288, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69172, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64800, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62720, 87),
      ))
    }

@delegate:ResourceContentHash(1_750_189_511)
internal val Res.string.exp_content_intro_vso_5: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_5", "exp_content_intro_vso_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67704, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67376, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69276, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64896, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62808, 71),
      ))
    }

@delegate:ResourceContentHash(1_861_089_431)
internal val Res.string.exp_content_intro_vso_6: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_6", "exp_content_intro_vso_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67788, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67452, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69356, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 64968, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62880, 95),
      ))
    }

@delegate:ResourceContentHash(-1_690_036_531)
internal val Res.string.exp_content_intro_vso_7: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_7", "exp_content_intro_vso_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 67880, 151),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67536, 135),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69448, 159),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65052, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 62976, 111),
      ))
    }

@delegate:ResourceContentHash(-744_007_200)
internal val Res.string.exp_content_intro_vso_8: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8", "exp_content_intro_vso_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68737, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68325, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70269, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65813, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63713, 75),
      ))
    }

@delegate:ResourceContentHash(-856_322_896)
internal val Res.string.exp_content_intro_vso_8_alyn_1: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_alyn_1", "exp_content_intro_vso_8_alyn_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68032, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67672, 78),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69608, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65176, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63088, 74),
      ))
    }

@delegate:ResourceContentHash(-457_886_452)
internal val Res.string.exp_content_intro_vso_8_alyn_2: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_alyn_2", "exp_content_intro_vso_8_alyn_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68119, 122),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67751, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69691, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65251, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63163, 106),
      ))
    }

@delegate:ResourceContentHash(-1_712_065_028)
internal val Res.string.exp_content_intro_vso_8_alyn_3: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_alyn_3", "exp_content_intro_vso_8_alyn_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68242, 130),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67874, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69814, 118),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65374, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63270, 106),
      ))
    }

@delegate:ResourceContentHash(147_133_993)
internal val Res.string.exp_content_intro_vso_8_alyn_4: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_alyn_4", "exp_content_intro_vso_8_alyn_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68373, 110),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 67993, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 69933, 106),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65493, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63377, 98),
      ))
    }

@delegate:ResourceContentHash(138_661_687)
internal val Res.string.exp_content_intro_vso_8_alyn_5: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_alyn_5", "exp_content_intro_vso_8_alyn_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68484, 78),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68100, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70040, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65596, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63476, 70),
      ))
    }

@delegate:ResourceContentHash(-60_540_116)
internal val Res.string.exp_content_intro_vso_8_nilo_1: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_nilo_1", "exp_content_intro_vso_8_nilo_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68563, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68167, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70107, 66),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65659, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63547, 70),
      ))
    }

@delegate:ResourceContentHash(1_773_639_547)
internal val Res.string.exp_content_intro_vso_8_nilo_2: StringResource by lazy {
      StringResource("string:exp_content_intro_vso_8_nilo_2", "exp_content_intro_vso_8_nilo_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68630, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68230, 94),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70174, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65722, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63618, 94),
      ))
    }

@delegate:ResourceContentHash(-357_814_137)
internal val Res.string.exp_content_l_infinito_1: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_1", "exp_content_l_infinito_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69287, 156),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68883, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70851, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66339, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64239, 164),
      ))
    }

@delegate:ResourceContentHash(-111_064_033)
internal val Res.string.exp_content_l_infinito_10: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_10", "exp_content_l_infinito_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68817, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68405, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70361, 93),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65885, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63789, 85),
      ))
    }

@delegate:ResourceContentHash(-1_336_024_756)
internal val Res.string.exp_content_l_infinito_11: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_11", "exp_content_l_infinito_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68903, 77),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68491, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70455, 77),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 65975, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63875, 81),
      ))
    }

@delegate:ResourceContentHash(837_987_494)
internal val Res.string.exp_content_l_infinito_12: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_12", "exp_content_l_infinito_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 68981, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68577, 125),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70533, 137),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66061, 121),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 63957, 121),
      ))
    }

@delegate:ResourceContentHash(540_493_625)
internal val Res.string.exp_content_l_infinito_13: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_13", "exp_content_l_infinito_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69107, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68703, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70671, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66183, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64079, 73),
      ))
    }

@delegate:ResourceContentHash(-1_937_042_203)
internal val Res.string.exp_content_l_infinito_14: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_14", "exp_content_l_infinito_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69193, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 68785, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 70761, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66253, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64153, 85),
      ))
    }

@delegate:ResourceContentHash(642_491_970)
internal val Res.string.exp_content_l_infinito_2: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_2", "exp_content_l_infinito_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69444, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69052, 60),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71024, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66500, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64404, 52),
      ))
    }

@delegate:ResourceContentHash(1_813_664_223)
internal val Res.string.exp_content_l_infinito_3: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_3", "exp_content_l_infinito_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69501, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69113, 108),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71085, 116),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66565, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64457, 104),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_l_infinito_4: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_4", "exp_content_l_infinito_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69610, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69222, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71202, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66666, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64562, 40),
      ))
    }

@delegate:ResourceContentHash(-1_454_151_199)
internal val Res.string.exp_content_l_infinito_5: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_5", "exp_content_l_infinito_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69651, 108),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69267, 104),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71247, 112),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66707, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64603, 108),
      ))
    }

@delegate:ResourceContentHash(-1_605_360_570)
internal val Res.string.exp_content_l_infinito_6: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_6", "exp_content_l_infinito_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69760, 188),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69372, 164),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71360, 188),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66808, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64712, 184),
      ))
    }

@delegate:ResourceContentHash(-262_645_943)
internal val Res.string.exp_content_l_infinito_7: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_7", "exp_content_l_infinito_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69949, 40),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69537, 44),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71549, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 66981, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64897, 44),
      ))
    }

@delegate:ResourceContentHash(234_916_200)
internal val Res.string.exp_content_l_infinito_8: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_8", "exp_content_l_infinito_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 69990, 172),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69582, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71598, 184),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67026, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 64942, 168),
      ))
    }

@delegate:ResourceContentHash(579_605_735)
internal val Res.string.exp_content_l_infinito_9: StringResource by lazy {
      StringResource("string:exp_content_l_infinito_9", "exp_content_l_infinito_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70163, 132),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69751, 124),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71783, 140),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67191, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65111, 116),
      ))
    }

@delegate:ResourceContentHash(1_484_964_821)
internal val Res.string.exp_content_la_forma_vso_1: StringResource by lazy {
      StringResource("string:exp_content_la_forma_vso_1", "exp_content_la_forma_vso_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70296, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69876, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 71924, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67316, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65228, 102),
      ))
    }

@delegate:ResourceContentHash(-301_841_379)
internal val Res.string.exp_content_la_forma_vso_2: StringResource by lazy {
      StringResource("string:exp_content_la_forma_vso_2", "exp_content_la_forma_vso_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70395, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 69975, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72023, 134),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67411, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65331, 134),
      ))
    }

@delegate:ResourceContentHash(872_506_005)
internal val Res.string.exp_content_la_forma_vso_3: StringResource by lazy {
      StringResource("string:exp_content_la_forma_vso_3", "exp_content_la_forma_vso_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70546, 138),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70110, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72158, 130),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67550, 130),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65466, 126),
      ))
    }

@delegate:ResourceContentHash(-1_984_333_300)
internal val Res.string.exp_content_la_forma_vso_4: StringResource by lazy {
      StringResource("string:exp_content_la_forma_vso_4", "exp_content_la_forma_vso_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70685, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70233, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72289, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67681, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65593, 90),
      ))
    }

@delegate:ResourceContentHash(-465_694_650)
internal val Res.string.exp_content_la_forma_vso_5: StringResource by lazy {
      StringResource("string:exp_content_la_forma_vso_5", "exp_content_la_forma_vso_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70792, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70332, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72400, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67776, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65684, 98),
      ))
    }

@delegate:ResourceContentHash(1_714_190_149)
internal val Res.string.exp_content_la_frase_misteriosa_1: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_1", "exp_content_la_frase_misteriosa_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71838, 73),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71346, 81),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73426, 81),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68726, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66638, 69),
      ))
    }

@delegate:ResourceContentHash(1_385_749_152)
internal val Res.string.exp_content_la_frase_misteriosa_10: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_10", "exp_content_la_frase_misteriosa_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 70919, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70443, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72503, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67891, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65783, 102),
      ))
    }

@delegate:ResourceContentHash(797_404_618)
internal val Res.string.exp_content_la_frase_misteriosa_11: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_11", "exp_content_la_frase_misteriosa_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71018, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70554, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72606, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 67994, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65886, 54),
      ))
    }

@delegate:ResourceContentHash(-633_145_568)
internal val Res.string.exp_content_la_frase_misteriosa_12: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_12", "exp_content_la_frase_misteriosa_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71073, 158),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70613, 150),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72669, 154),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68049, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 65941, 130),
      ))
    }

@delegate:ResourceContentHash(139_341_031)
internal val Res.string.exp_content_la_frase_misteriosa_13: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_13", "exp_content_la_frase_misteriosa_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71232, 50),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70764, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72824, 54),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68188, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66072, 50),
      ))
    }

@delegate:ResourceContentHash(-1_805_380_895)
internal val Res.string.exp_content_la_frase_misteriosa_14: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_14", "exp_content_la_frase_misteriosa_14", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71283, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70819, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 72879, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68239, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66123, 142),
      ))
    }

@delegate:ResourceContentHash(384_937_562)
internal val Res.string.exp_content_la_frase_misteriosa_15: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_15", "exp_content_la_frase_misteriosa_15", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71438, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 70962, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73046, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68374, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66266, 82),
      ))
    }

@delegate:ResourceContentHash(691_503_018)
internal val Res.string.exp_content_la_frase_misteriosa_16: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_16", "exp_content_la_frase_misteriosa_16", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71529, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71049, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73141, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68453, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66349, 142),
      ))
    }

@delegate:ResourceContentHash(-341_006_470)
internal val Res.string.exp_content_la_frase_misteriosa_17: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_17", "exp_content_la_frase_misteriosa_17", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71684, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71188, 54),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73280, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68580, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66492, 54),
      ))
    }

@delegate:ResourceContentHash(2_094_576_444)
internal val Res.string.exp_content_la_frase_misteriosa_18: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_18", "exp_content_la_frase_misteriosa_18", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71739, 98),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71243, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73343, 82),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68635, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66547, 90),
      ))
    }

@delegate:ResourceContentHash(2_005_985_790)
internal val Res.string.exp_content_la_frase_misteriosa_2: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_2", "exp_content_la_frase_misteriosa_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71912, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71428, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73508, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68800, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66708, 49),
      ))
    }

@delegate:ResourceContentHash(2_005_985_790)
internal val Res.string.exp_content_la_frase_misteriosa_3: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_3", "exp_content_la_frase_misteriosa_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 71962, 49),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71482, 53),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73558, 49),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68850, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66758, 49),
      ))
    }

@delegate:ResourceContentHash(1_540_698_965)
internal val Res.string.exp_content_la_frase_misteriosa_4: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_4", "exp_content_la_frase_misteriosa_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72012, 97),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71536, 97),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73608, 89),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68900, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66808, 85),
      ))
    }

@delegate:ResourceContentHash(544_279_917)
internal val Res.string.exp_content_la_frase_misteriosa_5: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_5", "exp_content_la_frase_misteriosa_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72110, 165),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71634, 165),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73698, 177),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 68994, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 66894, 153),
      ))
    }

@delegate:ResourceContentHash(412_077_522)
internal val Res.string.exp_content_la_frase_misteriosa_6: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_6", "exp_content_la_frase_misteriosa_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72276, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71800, 57),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73876, 57),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69160, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67048, 57),
      ))
    }

@delegate:ResourceContentHash(119_011_404)
internal val Res.string.exp_content_la_frase_misteriosa_7: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_7", "exp_content_la_frase_misteriosa_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72330, 109),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71858, 133),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 73934, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69218, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67106, 101),
      ))
    }

@delegate:ResourceContentHash(1_524_227_859)
internal val Res.string.exp_content_la_frase_misteriosa_8: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_8", "exp_content_la_frase_misteriosa_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72440, 69),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 71992, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74060, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69344, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67208, 73),
      ))
    }

@delegate:ResourceContentHash(918_600_035)
internal val Res.string.exp_content_la_frase_misteriosa_9: StringResource by lazy {
      StringResource("string:exp_content_la_frase_misteriosa_9", "exp_content_la_frase_misteriosa_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72510, 93),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72066, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74130, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69406, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67282, 89),
      ))
    }

@delegate:ResourceContentHash(417_519_230)
internal val Res.string.exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_: StringResource by
    lazy {
      StringResource("string:exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_", "exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72604, 233),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72152, 221),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74232, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69492, 213),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67372, 193),
      ))
    }

@delegate:ResourceContentHash(-266_738_574)
internal val Res.string.exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_: StringResource by
    lazy {
      StringResource("string:exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_", "exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 72838, 293),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72374, 273),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74454, 265),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69706, 261),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67566, 241),
      ))
    }

@delegate:ResourceContentHash(-87_491_139)
internal val Res.string.exp_content_la_particella_ni_1: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_1", "exp_content_la_particella_ni_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73688, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73208, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75292, 62),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70480, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68344, 66),
      ))
    }

@delegate:ResourceContentHash(1_746_914_924)
internal val Res.string.exp_content_la_particella_ni_10: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_10", "exp_content_la_particella_ni_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73132, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72648, 115),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74720, 123),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 69968, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67808, 115),
      ))
    }

@delegate:ResourceContentHash(-711_799_592)
internal val Res.string.exp_content_la_particella_ni_11: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_11", "exp_content_la_particella_ni_11", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73244, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72764, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74844, 115),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70084, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67924, 95),
      ))
    }

@delegate:ResourceContentHash(51_134_045)
internal val Res.string.exp_content_la_particella_ni_12: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_12", "exp_content_la_particella_ni_12", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73348, 155),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 72872, 147),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 74960, 151),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70180, 135),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68020, 155),
      ))
    }

@delegate:ResourceContentHash(-1_785_293_337)
internal val Res.string.exp_content_la_particella_ni_13: StringResource by lazy {
      StringResource("string:exp_content_la_particella_ni_13", "exp_content_la_particella_ni_13", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 73504, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 73020, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 75112, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 70316, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 68176, 95),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("exp_content_il_verbo_ma_i_9", Res.string.exp_content_il_verbo_ma_i_9)
  map.put("exp_content_impariamo_alcune_parole_base_sugli_animali", Res.string.exp_content_impariamo_alcune_parole_base_sugli_animali)
  map.put("exp_content_impariamo_alcune_parole_base_sul_cibo", Res.string.exp_content_impariamo_alcune_parole_base_sul_cibo)
  map.put("exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit", Res.string.exp_content_impariamo_alcune_parole_di_cibi_animali_e_tit)
  map.put("exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili", Res.string.exp_content_impariamo_i_nomi_delle_persone_i_ruoli_famili)
  map.put("exp_content_impariamo_pronomi_suffissi", Res.string.exp_content_impariamo_pronomi_suffissi)
  map.put("exp_content_impariamo_pronomi_suffissi_1", Res.string.exp_content_impariamo_pronomi_suffissi_1)
  map.put("exp_content_impariamo_pronomi_suffissi_2", Res.string.exp_content_impariamo_pronomi_suffissi_2)
  map.put("exp_content_in_egiziano_antico_non_c_erano_regole_rigide_", Res.string.exp_content_in_egiziano_antico_non_c_erano_regole_rigide_)
  map.put("exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost", Res.string.exp_content_in_egiziano_antico_per_fare_un_elenco_di_sost)
  map.put("exp_content_in_genere_si_mettono_alla_fine_della_parola_m", Res.string.exp_content_in_genere_si_mettono_alla_fine_della_parola_m)
  map.put("exp_content_in_italiano_usiamo_preposizioni_articolate_co", Res.string.exp_content_in_italiano_usiamo_preposizioni_articolate_co)
  map.put("exp_content_in_mezzo_quadrato_orizzontale", Res.string.exp_content_in_mezzo_quadrato_orizzontale)
  map.put("exp_content_in_mezzo_quadrato_verticale", Res.string.exp_content_in_mezzo_quadrato_verticale)
  map.put("exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_", Res.string.exp_content_in_questa_lezione_vedremo_alcuni_nomi_propri_)
  map.put("exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s", Res.string.exp_content_in_questa_sezione_vedremo_i_diversi_tipi_di_s)
  map.put("exp_content_in_questa_sezione_vedremo_i_principali_fondam", Res.string.exp_content_in_questa_sezione_vedremo_i_principali_fondam)
  map.put("exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt", Res.string.exp_content_in_questa_stanza_ci_sono_molte_mummie_di_gatt)
  map.put("exp_content_in_questo_caso_invece_di_indicare_un_suono_in", Res.string.exp_content_in_questo_caso_invece_di_indicare_un_suono_in)
  map.put("exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non", Res.string.exp_content_in_realt_il_simbolo_genitivo_e_n_y_ma_la_y_non)
  map.put("exp_content_in_un_quarto_di_quadrato", Res.string.exp_content_in_un_quarto_di_quadrato)
  map.put("exp_content_in_viaggio_sul_nilo_1", Res.string.exp_content_in_viaggio_sul_nilo_1)
  map.put("exp_content_in_viaggio_sul_nilo_10", Res.string.exp_content_in_viaggio_sul_nilo_10)
  map.put("exp_content_in_viaggio_sul_nilo_11", Res.string.exp_content_in_viaggio_sul_nilo_11)
  map.put("exp_content_in_viaggio_sul_nilo_12", Res.string.exp_content_in_viaggio_sul_nilo_12)
  map.put("exp_content_in_viaggio_sul_nilo_13", Res.string.exp_content_in_viaggio_sul_nilo_13)
  map.put("exp_content_in_viaggio_sul_nilo_14", Res.string.exp_content_in_viaggio_sul_nilo_14)
  map.put("exp_content_in_viaggio_sul_nilo_2", Res.string.exp_content_in_viaggio_sul_nilo_2)
  map.put("exp_content_in_viaggio_sul_nilo_3", Res.string.exp_content_in_viaggio_sul_nilo_3)
  map.put("exp_content_in_viaggio_sul_nilo_4", Res.string.exp_content_in_viaggio_sul_nilo_4)
  map.put("exp_content_in_viaggio_sul_nilo_5", Res.string.exp_content_in_viaggio_sul_nilo_5)
  map.put("exp_content_in_viaggio_sul_nilo_6", Res.string.exp_content_in_viaggio_sul_nilo_6)
  map.put("exp_content_in_viaggio_sul_nilo_7", Res.string.exp_content_in_viaggio_sul_nilo_7)
  map.put("exp_content_in_viaggio_sul_nilo_8", Res.string.exp_content_in_viaggio_sul_nilo_8)
  map.put("exp_content_in_viaggio_sul_nilo_9", Res.string.exp_content_in_viaggio_sul_nilo_9)
  map.put("exp_content_incredibile_abbiamo_appena_fatto_una_scoperta", Res.string.exp_content_incredibile_abbiamo_appena_fatto_una_scoperta)
  map.put("exp_content_infatti_se_necessario_i_segni_potevano_essere", Res.string.exp_content_infatti_se_necessario_i_segni_potevano_essere)
  map.put("exp_content_iniziamo_a_leggere_qualche_parola", Res.string.exp_content_iniziamo_a_leggere_qualche_parola)
  map.put("exp_content_iniziamo_a_studiare_i_primi_simboli", Res.string.exp_content_iniziamo_a_studiare_i_primi_simboli)
  map.put("exp_content_iniziamo_col_caso_piu_semplice", Res.string.exp_content_iniziamo_col_caso_piu_semplice)
  map.put("exp_content_insomma_ci_vuole_un_po_di_pratica", Res.string.exp_content_insomma_ci_vuole_un_po_di_pratica)
  map.put("exp_content_intro_vso_1", Res.string.exp_content_intro_vso_1)
  map.put("exp_content_intro_vso_2", Res.string.exp_content_intro_vso_2)
  map.put("exp_content_intro_vso_3", Res.string.exp_content_intro_vso_3)
  map.put("exp_content_intro_vso_4", Res.string.exp_content_intro_vso_4)
  map.put("exp_content_intro_vso_5", Res.string.exp_content_intro_vso_5)
  map.put("exp_content_intro_vso_6", Res.string.exp_content_intro_vso_6)
  map.put("exp_content_intro_vso_7", Res.string.exp_content_intro_vso_7)
  map.put("exp_content_intro_vso_8", Res.string.exp_content_intro_vso_8)
  map.put("exp_content_intro_vso_8_alyn_1", Res.string.exp_content_intro_vso_8_alyn_1)
  map.put("exp_content_intro_vso_8_alyn_2", Res.string.exp_content_intro_vso_8_alyn_2)
  map.put("exp_content_intro_vso_8_alyn_3", Res.string.exp_content_intro_vso_8_alyn_3)
  map.put("exp_content_intro_vso_8_alyn_4", Res.string.exp_content_intro_vso_8_alyn_4)
  map.put("exp_content_intro_vso_8_alyn_5", Res.string.exp_content_intro_vso_8_alyn_5)
  map.put("exp_content_intro_vso_8_nilo_1", Res.string.exp_content_intro_vso_8_nilo_1)
  map.put("exp_content_intro_vso_8_nilo_2", Res.string.exp_content_intro_vso_8_nilo_2)
  map.put("exp_content_l_infinito_1", Res.string.exp_content_l_infinito_1)
  map.put("exp_content_l_infinito_10", Res.string.exp_content_l_infinito_10)
  map.put("exp_content_l_infinito_11", Res.string.exp_content_l_infinito_11)
  map.put("exp_content_l_infinito_12", Res.string.exp_content_l_infinito_12)
  map.put("exp_content_l_infinito_13", Res.string.exp_content_l_infinito_13)
  map.put("exp_content_l_infinito_14", Res.string.exp_content_l_infinito_14)
  map.put("exp_content_l_infinito_2", Res.string.exp_content_l_infinito_2)
  map.put("exp_content_l_infinito_3", Res.string.exp_content_l_infinito_3)
  map.put("exp_content_l_infinito_4", Res.string.exp_content_l_infinito_4)
  map.put("exp_content_l_infinito_5", Res.string.exp_content_l_infinito_5)
  map.put("exp_content_l_infinito_6", Res.string.exp_content_l_infinito_6)
  map.put("exp_content_l_infinito_7", Res.string.exp_content_l_infinito_7)
  map.put("exp_content_l_infinito_8", Res.string.exp_content_l_infinito_8)
  map.put("exp_content_l_infinito_9", Res.string.exp_content_l_infinito_9)
  map.put("exp_content_la_forma_vso_1", Res.string.exp_content_la_forma_vso_1)
  map.put("exp_content_la_forma_vso_2", Res.string.exp_content_la_forma_vso_2)
  map.put("exp_content_la_forma_vso_3", Res.string.exp_content_la_forma_vso_3)
  map.put("exp_content_la_forma_vso_4", Res.string.exp_content_la_forma_vso_4)
  map.put("exp_content_la_forma_vso_5", Res.string.exp_content_la_forma_vso_5)
  map.put("exp_content_la_frase_misteriosa_1", Res.string.exp_content_la_frase_misteriosa_1)
  map.put("exp_content_la_frase_misteriosa_10", Res.string.exp_content_la_frase_misteriosa_10)
  map.put("exp_content_la_frase_misteriosa_11", Res.string.exp_content_la_frase_misteriosa_11)
  map.put("exp_content_la_frase_misteriosa_12", Res.string.exp_content_la_frase_misteriosa_12)
  map.put("exp_content_la_frase_misteriosa_13", Res.string.exp_content_la_frase_misteriosa_13)
  map.put("exp_content_la_frase_misteriosa_14", Res.string.exp_content_la_frase_misteriosa_14)
  map.put("exp_content_la_frase_misteriosa_15", Res.string.exp_content_la_frase_misteriosa_15)
  map.put("exp_content_la_frase_misteriosa_16", Res.string.exp_content_la_frase_misteriosa_16)
  map.put("exp_content_la_frase_misteriosa_17", Res.string.exp_content_la_frase_misteriosa_17)
  map.put("exp_content_la_frase_misteriosa_18", Res.string.exp_content_la_frase_misteriosa_18)
  map.put("exp_content_la_frase_misteriosa_2", Res.string.exp_content_la_frase_misteriosa_2)
  map.put("exp_content_la_frase_misteriosa_3", Res.string.exp_content_la_frase_misteriosa_3)
  map.put("exp_content_la_frase_misteriosa_4", Res.string.exp_content_la_frase_misteriosa_4)
  map.put("exp_content_la_frase_misteriosa_5", Res.string.exp_content_la_frase_misteriosa_5)
  map.put("exp_content_la_frase_misteriosa_6", Res.string.exp_content_la_frase_misteriosa_6)
  map.put("exp_content_la_frase_misteriosa_7", Res.string.exp_content_la_frase_misteriosa_7)
  map.put("exp_content_la_frase_misteriosa_8", Res.string.exp_content_la_frase_misteriosa_8)
  map.put("exp_content_la_frase_misteriosa_9", Res.string.exp_content_la_frase_misteriosa_9)
  map.put("exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_", Res.string.exp_content_la_lettura_pu_essere_da_destra_a_sinistra_da_)
  map.put("exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_", Res.string.exp_content_la_parola_balia_mna_in_realt_scritta_mnna_la_)
  map.put("exp_content_la_particella_ni_1", Res.string.exp_content_la_particella_ni_1)
  map.put("exp_content_la_particella_ni_10", Res.string.exp_content_la_particella_ni_10)
  map.put("exp_content_la_particella_ni_11", Res.string.exp_content_la_particella_ni_11)
  map.put("exp_content_la_particella_ni_12", Res.string.exp_content_la_particella_ni_12)
  map.put("exp_content_la_particella_ni_13", Res.string.exp_content_la_particella_ni_13)
}
